<template>
  <div class="father-module warn-module flex flex-v">
    <!-- 案卷列表 -->
    <div class="title-module flex flex-align-center flex-pack-justify">
      <img
        src="@/assets/image/layout/mod-title.png"
        alt=""
        class="title-module-img"
      />
      <div>告警列表</div>
      <span class="num">总计：{{ baojingNum }}</span>
      <a href="javascript:;" class="more" @click="xiangqing">查看更多</a>
    </div>
    <div class="flex-1 warn-module-main">
      <scroll-top
        :data="tableData"
        :class-option="optionSingleHeight"
        class="seamless-warp"
      >
        <ul class="item">
          <li
            v-for="(item, index) in tableData"
            :key="index"
            @click="itemClick(item)"
            class="items"
          >
            <div class="flex flex-align-center flex-pack-justify">
              <div class="name">{{ item.equipmentTypeName }}</div>
              <div class="time">{{ item.createTime }}</div>
            </div>
            <div class="line"></div>
            <div class="flex flex-align-center flex-pack-justify">
              <div>{{ item.equipmentName }}</div>
              <div class="num">
                <i
                  class="el-icon-top"
                  style="color: #ff3800"
                  v-if="item.dataValue > item.endWarningValue"
                ></i>
                <i
                  v-else-if="item.dataValue < item.beginWarningValue"
                  class="el-icon-bottom"
                  style="color: #e62121"
                ></i>
                {{ item.dataValue }}
              </div>
            </div>
          </li>
        </ul>
      </scroll-top>
    </div>
    <!-- <div class="left-box1"> -->
    <!-- <div class="title-module">
				<div>
					<img src="@/assets/image/jieshao.png" alt="" class="title-module-img" />
					案卷列表
					<span>共{{ anjuanNum }}条</span>
				</div>
				<div class="details" @click="xiangqing">查看详情</div>
			</div>
			 -->
    <!-- <scroll-top :data="tableData" :class-option="optionSingleHeight" class="seamless-warp">
				<ul class="item">
					<li v-for="(item, index) in tableData" :key="index" @click="itemClick(item)" class="items">
						{{ item.createTime }} {{ item.reportPeopleName }} 在{{ item.locationdDescribe }}的
						<span style="color: #1C9BB1;">【{{ item.bridgeName }}】</span>
						提交设施损坏案卷请及时关注
					</li>
				</ul>
			</scroll-top> -->

    <!-- </div> -->
  </div>
</template>

<script>
import scrollTop from '../../components/scroll.vue'

export default {
  name: 'rightBottom',
  components: {
    scrollTop
  },
  data() {
    return {
      tableData: [],
      baojingNum: 0,
      timmerScrol: null
    }
  },
  props: {
    bridgeObj: {
      type: Object,
      default: {}
    }
  },
  watch: {},
  methods: {
    //获取报警列表
    async getbaojing() {
      let daySart = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      ).Format('yyyy-MM-dd HH:mm:ss')
      let dayEnd = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      ).Format('yyyy-MM-dd HH:mm:ss')
      let data = {
        pageNum: 1,
        pageSize: 9999,
        beginTime: daySart,
        endTime: dayEnd,
        state: 0
      }
      // console.log(data);
      const res = await this.$api.sendPost(
        '/earlyWarning/getAllEarlyWarningAlarm',
        data
      )
      // console.log('报警列表', res);
      this.baojingNum = res.data.total
      this.tableData = res.data.list
    },
    //时间
    timechange() {
      Date.prototype.Format = function (fmt) {
        var o = {
          'M+': this.getMonth() + 1, //月份
          'd+': this.getDate(), //日
          'H+': this.getHours(), //小时
          'm+': this.getMinutes(), //分
          's+': this.getSeconds(), //秒
          'q+': Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds() //毫秒
        }
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        for (var k in o)
          if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
        return fmt
      }
    },
    //跳转预警报警情况
    xiangqing() {
      this.$router.push(`/home/yujingbaojingqingkuang`)
    }
  },
  computed: {
    // 滚动动画
    optionSingleHeight() {
      return {
        step: 0.3,
        direction: 1,
        limitMoveNum: 5,
        openWatch: true
      }
    }
  },

  created() {},
  mounted() {
    // let b = '2022-07-30 16:20:31 李某某 在浙江省湖州市德清县【新安江大桥】提交设施损坏案卷请及时关注。'
    // this.tableData = Array(20).fill(b)
    this.timechange()
    this.getbaojing()
    clearInterval(this.timmerScrol)
    this.timmerScrol = null
    this.timmerScrol = setInterval(() => {
      this.getbaojing()
    }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.timmerScrol)
    this.timmerScrol = null
  },
  destroyed() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.father-module .title-module .more {
  margin-top: 0;
}

.warn-module {
  height: 100%;

  .warn-module-main {
    min-height: 0;
    margin-bottom: 20px;
    overflow: auto;

    .item {
      .items {
        font-size: 14px;
        color: #f4faff;
        background: linear-gradient(
          134deg,
          rgba(43, 109, 255, 0.3) 0%,
          rgba(77, 221, 255, 0.2) 100%
        );
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 6px;

        .time {
          font-size: 12px;
        }

        .name {
          font-weight: 800;
        }

        .num {
          font-weight: 800;
          color: #0de4de;

          &.orange {
            color: #fdaa00;
          }

          &.red {
            color: #ff3636;
          }
        }

        .line {
          height: 1px;
          margin: 6px 0;
          background: linear-gradient(
            90deg,
            #0ec4dd 0%,
            rgba(7, 114, 111, 0) 100%
          );
        }
      }
    }
  }
}

.seamless-warp {
  width: 100%;
  height: calc(100% - 0px);
  overflow: auto;

  .items {
    font-size: 16px;
    color: #ffffff;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-align: left;
    margin-bottom: 14px;
    letter-spacing: 1;
  }
}
</style>
